import { flightTypes, workplaceTypes } from "../types";
import { DepartureFlightInfoBlock } from "../FlightBlock/DepartureFlightInfoBlock";
import { ArrivalFlightInfoBlock } from "../FlightBlock/ArrivalFlightInfoBlock";
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { appNotification } from '@/components/AppNotification.js'
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { HeaderMenuBlock } from '@/Block/HeaderMenuBlock/HeaderMenuBlock'
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';
import { ModalContainerTelegram } from "../Modal/ModalContainerTelegram";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';


function changeClass(el, currentClass, newClass) {
    if( el !== null ) {
        el.classList.remove(currentClass);
        el.classList.add(newClass);
    }
}

function turnInfo(PV) {
    var currentClass, newClass;
    var info, info_obr;
    var turnButton = document.getElementById("turnButton");
    turnButton.remove();
    let element = ("button");
    turnButton = document.createElement(element);

    turnButton.id = "turnButton";
    info = localStorage.getItem("info1");
    info = JSON.parse(info);

    info_obr = localStorage.getItem("info2");
    info_obr = JSON.parse(info_obr);

    if(info_obr == "")
        location.reload();

    var arrInfo, arrInfo_obr;

    if(PV == 'В') {
        currentClass = 'bg-info';
        newClass = 'bg-danger';
        arrInfo = info['PV'] == 'В' ? info : info_obr;
        arrInfo_obr = info['PV'] != 'В' ? info : info_obr;
        arrInfo_obr["BORT"] = arrInfo_obr["BORT"] == "" ? "<->" : arrInfo_obr["BORT"];
        arrInfo_obr["DTFM"] = arrInfo_obr["DTFM"] == "" ? "--:--" : arrInfo_obr["DTFM"];

        turnButton.className = "btn btn-block block-arrival";
        //changeClass(turnButton, 'block-departure', 'block-arrival');
        turnButton.onclick = function () { turnInfo('П'); }
        turnButton.textContent = arrInfo_obr["NR"]+ " " + arrInfo_obr["BORT"]+ " "+
                        arrInfo_obr["planDate"]+" "+arrInfo_obr["planTime"]+" / "+arrInfo_obr["DTFM"];
        document.getElementById("titleButton").innerText = "Информация по рейсу прилета:";
        document.getElementById("titleButton").className = "text-center";
    }
    else {
        currentClass = 'bg-danger';
        newClass = 'bg-info';
        arrInfo = info['PV'] == 'П' ? info : info_obr;
        arrInfo_obr = info['PV'] != 'П' ? info : info_obr;
        arrInfo_obr["BORT"] = arrInfo_obr["BORT"] == "" ? "<->" : arrInfo_obr["BORT"];
        arrInfo_obr["DTFM"] = arrInfo_obr["DTFM"] == "" ? "--:--" : arrInfo_obr["DTFM"];
        //changeClass(turnButton,  'block-arrival','block-departure');
        turnButton.className = "btn btn-block block-departure";
        turnButton.onclick = function () { turnInfo('В'); }
        turnButton.textContent = arrInfo_obr["NR"]+ " " + arrInfo_obr["BORT"]+ " "+arrInfo_obr["planDate"]+" "+
                        arrInfo_obr["planTime"]+" / "+arrInfo_obr["DTFM"];
        document.getElementById("titleButton").innerText = "Информация по рейсу вылета:";
        document.getElementById("titleButton").className = "text-center";
    }

    var arrElementID = ['NR', 'TS_ICAO', 'BORT', 'NST', 'route', 'planTime',
                    'DTFM', 'DTVPM', 'VPEM', 'KCE', 'KBP', 'TECHNICS', 'KPASF', 'KVZRF', 'KRBF', 'KRMF',
                    'GRUZ', 'POCHTA', 'KBAGC', 'PRIM', 'PRICHF', 'DZADF', 'BVZR', 'BRB', 'BRM', 'BPOCHTA',
                    'ssr', 'danger_cargo', 'special_cargo', 'transf', 'BBAG', 'BGRUZ'];

    for (let i = 0; i < arrElementID.length; i++) {
        changeClass(document.getElementById(arrElementID[i]), currentClass, newClass);
        if( document.getElementById(arrElementID[i]) !== null )
            document.getElementById(arrElementID[i]).innerText =
                                arrInfo[arrElementID[i]] == "" || arrInfo[arrElementID[i]] == null ? '\xa0' : arrInfo[arrElementID[i]];

        if( document.getElementById('PRIM') !== null )
            document.getElementById('PRIM').innerText =
                arrInfo['PRIM'] == "" || arrInfo['PRIM'] == null ? ' ' : arrInfo['PRIM'];

        if( document.getElementById('route') !== null )
            document.getElementById('route').innerText =
                arrInfo['route'] + (arrInfo['planDate'] ? " [" + arrInfo['planDate'] + "]" : "");

        if( document.getElementById('transf') !== null )
            document.getElementById('transf').innerText = (arrInfo['transf_in']  || "-") + '/' +
                (arrInfo['transf_out'] || "-");

        if( document.getElementById('BBAG') !== null )
            document.getElementById('BBAG').innerText =
                 String(arrInfo['BBAGPLC'] || "-") + '/' + String(arrInfo['BBAG'] || "-");

        if( document.getElementById('BGRUZ') !== null )
            document.getElementById('BGRUZ').innerText =
                String(arrInfo['BGRUZPLC'] || "-") + '/' + String(arrInfo['BGRUZ'] || "-") + '/' +
                String(arrInfo['BGRUZVLM'] || "-");
    }

    var TitleF = document.getElementById("TitleF");
    TitleF.innerHTML = "";

    var newRow = document.createElement("div");
    newRow.className = "row";
    if(arrInfo['TitleF'] != null) {
        let i = document.createElement("i");
        i.className = "fa fa-info-circle";

        let span = document.createElement("span");
        span.innerText = " " + arrInfo['TitleF'];

        let div = document.createElement("div");
        div.className = "alert alert-warning";
        div.appendChild(i);
        div.appendChild(span);

        let col = document.createElement("div");
        col.className = "col-xs-12";
        col.style = "padding:0 10px";
        col.appendChild(div);
        newRow.appendChild(col);
    }
    TitleF.appendChild(newRow);

    var KZAF = document.getElementById("KZAF");
    KZAF.innerHTML = "";

    newRow = document.createElement("div");
    newRow.className = "row";
    arrInfo['KZAF'].map(function (field) {
        let p = document.createElement("p");
        p.className = "text-center " + newClass;
        p.innerText = field.title;

        let col = document.createElement("div");
        col.className = "col-xs-6";
        col.style = "padding:0 5px 0 10px";
        col.appendChild(p);
        newRow.appendChild(col);

        p = document.createElement("p");
        p.className = "text-center " + newClass;
        p.innerText = field.value;

        col = document.createElement("div");
        col.className = "col-xs-6";
        col.style = "padding:0 10px 0 5px";
        col.appendChild(p);
        newRow.appendChild(col);
    });
    KZAF.appendChild(newRow);

    //Предупреждения
    var alertInfo = document.getElementById("alertInfo");
    alertInfo.innerHTML = "";

    newRow = document.createElement("div");
    newRow.className = "row";
    if(arrInfo['alerts'].length > 0) {
        arrInfo['alerts'].map(function (alert) {
            let p = document.createElement("p");
            p.className = "bg-warning progress-bar-striped text-center";
            p.innerText = alert.code;

            let col = document.createElement("div");
            col.className = "col-xs-3";
            col.style = "padding:0 5px 0 10px";
            col.appendChild(p);
            newRow.appendChild(col);

            p = document.createElement("p");
            p.className = "bg-warning progress-bar-striped text-center";
            p.innerText = alert.desc;

            col = document.createElement("div");
            col.className = "col-xs-7";
            col.style = "padding:0 5px";
            col.appendChild(p);
            newRow.appendChild(col);

            p = document.createElement("p");
            p.className = "bg-warning progress-bar-striped text-center";
            p.innerText = alert.amount;

            col = document.createElement("div");
            col.className = "col-xs-2";
            col.style = "padding:0 10px 0 5px";
            col.appendChild(p);
            newRow.appendChild(col);
        });
    }
    else {
        let p = document.createElement("p");
        p.className = "text-center " + newClass;
        p.innerText = ' ';

        let col = document.createElement("div");
        col.className = "col-xs-12";
        col.style = "padding:0 10px 0 10px";
        col.appendChild(p);
        newRow.appendChild(col);
    }
    alertInfo.appendChild(newRow);

    //Данные по отсекам
    var DL = document.getElementById("DL");
    DL.innerHTML = "";

    newRow = document.createElement("div");
    newRow.className = "row";
    if(arrInfo['DL'].length > 0) {
        arrInfo['DL'].map(function (info) {
            let p = document.createElement("p");
            p.className = "text-center " + newClass;
            p.innerText = info.Comp + ': ' + (info.containers || '-') + ' / ' + (info.Weight || '-') + (info.type ? ' [' + info.type + ']' : '');

            let col = document.createElement("div");
            col.className = "col-xs-12";
            col.style = "padding:0 10px";
            col.appendChild(p);
            newRow.appendChild(col);
        });
    }
    else {
        let p = document.createElement("p");
        p.className = "text-center " + newClass;
        p.innerText = ' ';

        let col = document.createElement("div");
        col.className = "col-xs-12";
        col.style = "padding:0 10px 0 10px";
        col.appendChild(p);
        newRow.appendChild(col);
    }
    DL.appendChild(newRow);

    //Трансферные пассажиры
    var transfer = document.getElementById("transfer");
    transfer.innerHTML = "";

    newRow = document.createElement("div");
    newRow.className = "row";
    if(arrInfo['transfer'].length > 0) {
        arrInfo['transfer'].map(function (tran) {
            let p = document.createElement("p");
            p.className = "text-center " + newClass;
            p.style = "padding: 7px 10px;"
            p.innerText = tran.tr_date + '/' + tran.tr_time + '/' + tran.tr_nr + '/' + tran.tr_ap;

            let col = document.createElement("div");
            col.className = "col-xs-7";
            col.style = "padding:0 5px 0 10px";
            col.appendChild(p);
            newRow.appendChild(col);

            p = document.createElement("p");
            p.className = "text-center " + newClass;
            p.innerText = (tran.tr_kpax || '-') + ' / ' + (tran.tr_kbag || '-') + ' / ' + (tran.tr_vbag || '-');

            col = document.createElement("div");
            col.className = "col-xs-5";
            col.style = "padding:0 10px";
            col.appendChild(p);
            newRow.appendChild(col);
        });
    }
    else {
        let p = document.createElement("p");
        p.className = "text-center " + newClass;
        p.innerText = ' ';

        let col = document.createElement("div");
        col.className = "col-xs-12";
        col.style = "padding:0 10px 0 10px";
        col.appendChild(p);
        newRow.appendChild(col);
    }
    transfer.appendChild(newRow);

    //Телеграммы
    var telegram = document.getElementById("telegram");
    telegram.innerHTML = "";

    newRow = document.createElement("div");
    newRow.className = "row";
    if(arrInfo['TEL'].length > 0) {
        arrInfo['TEL'].map(function (field) {
            var button_tel = document.createElement("button");
            button_tel.type = "submit";
            if(newClass === 'bg-danger')
                button_tel.className = "btn btn-block btn-lg " + 'btn-danger';
            else
                button_tel.className = "btn btn-block btn-lg " + 'btn-info';
            button_tel.innerText = field.ID_TEL + " " + field.DTime;
            button_tel.onclick = function () { ModalContainerTelegram.open(field.TEXT); }

            let col = document.createElement("div");
            col.className = "col-xs-12";
            col.style = "margin:5px 0";
            col.appendChild(button_tel);
            newRow.appendChild(col);
        });
    }
    else {
        let p = document.createElement("p");
        p.className = "text-center " + newClass;
        p.innerText = ' ';

        let col = document.createElement("div");
        col.className = "col-xs-12";
        col.style = "padding:0 10px 0 10px";
        col.appendChild(p);
        newRow.appendChild(col);
    }
    telegram.appendChild(newRow);


    if(document.getElementById("titleBlock"))
        document.getElementById("titleBlock").remove();

    if(PV == info_obr["PV"]) {
        document.getElementById('rowTurnButton').style = "padding-top:10px;background-color: #e6e6e6";
        document.getElementById('containerInfo').style = "padding-top:10px;background-color: #e6e6e6";
    }
    else {
        document.getElementById('rowTurnButton').style = "padding-top:10px;background-color: initial";
        document.getElementById('containerInfo').style = "padding-top:10px;background-color: initial";
    }
    document.getElementById('rowTurnButton').appendChild(turnButton);

    element = ("p");
    let titleBlock = document.createElement(element);
    titleBlock.id = "titleBlock";
    titleBlock.className = "text-center";
    titleBlock.style = "margin-top: 5px;";
    titleBlock.innerText = PV == 'В' ? "Информация по рейсу вылета:" : "Информация по рейсу прилета:";
    document.getElementById('rowTurnButton').appendChild(titleBlock);
}

export var TaskFlightInfoPage = {
    controller: function () {
        var self = this;

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        if (user.get('state.workplace') === workplaceTypes.driver) {
            this.topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];

            if (user.get('state.vehicleFreeTasksAvailable')) {
                this.topMenu.unshift(
                    { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
                )
            }
        } else if (user.get('state.workplace') === workplaceTypes.agent) {
            this.topMenu = [
                { title: 'Задачи', url: '/agent/tasks', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        } else {
            this.topMenu = [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        }

        this.data = m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/info'
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;

            appNotification.list = response.notifications;

            server.initPing();
            appNotification.init();

            let info1 = JSON.stringify(response.info);
            localStorage.setItem("info1", info1);

            let info2 = JSON.stringify(response.info_obr);
            localStorage.setItem("info2", info2);

            let flightId = JSON.stringify(response.currentTask.flightId);
            localStorage.setItem("flightId", flightId);

            appNotification.load()

            return response;
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });

    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", [
                VehicleNumberBlock(),
                m.component(flightMenuBlock, {
                    board: ctrl.data().board,
                    menu: ctrl.data().menu,
                    tasks: ctrl.data().tasks,
                    currentTask: ctrl.data().currentTask,
                    tab: 'info'
                })
            ]),
            ctrl.errmsg,
            ctrl.data().info_obr !== "" && ctrl.data().config.InfoTurnaroundFlight ?
                m(".container[style='padding-top:10px'][id='rowTurnButton']", [
                    ctrl.data().info.type === flightTypes.departure ? [
                        m("p.text-center[id='titleButton']", "Информация по рейсу прилета:"),
                        m("button.btn.btn-block.block-arrival[style='border-radius: 5px'][id='turnButton']",
                            {
                                onclick: function () {
                                    turnInfo('П');
                                }
                            }, ctrl.data().info_obr.NR + " " +
                            (ctrl.data().info_obr.BORT == "" ? "<->" : ctrl.data().info_obr.BORT) + " " +
                            ctrl.data().info_obr.planDate +" " + ctrl.data().info_obr.planTime + " / " +
                            (ctrl.data().info_obr.DTFM == "" ? "--:--" : ctrl.data().info_obr.DTFM) )
                        ] : [
                        m("p.text-center[id='titleButton']", "Информация по рейсу вылета:"),
                        m("button.btn.btn-block.block-departure[style='border-radius: 5px'][id='turnButton']",
                            {
                                onclick: function () {
                                    turnInfo('В');
                                }
                            }, ctrl.data().info_obr.NR + " " +
                            (ctrl.data().info_obr.BORT == "" ? "<->" : ctrl.data().info_obr.BORT) + " " +
                            ctrl.data().info_obr.planDate +" " + ctrl.data().info_obr.planTime + " / " +
                            (ctrl.data().info_obr.DTFM == "" ? "--:--" : ctrl.data().info_obr.DTFM) ) ]
                ]) : "",

            ctrl.data().info.type === flightTypes.departure ? [
                m.component(DepartureFlightInfoBlock, {
                    data: ctrl.data().info,
                    info_obr: ctrl.data().info_obr,
                    showBookingBlock: ctrl.data().config.openSkyBlocksShow,
                    infoTurnaroundFlight: ctrl.data().config.InfoTurnaroundFlight,
                    infoFlightTimeTransPax: ctrl.data().config.InfoFlightTimeTransPax,
                }) ] : [
                    m.component(ArrivalFlightInfoBlock, {
                        data: ctrl.data().info,
                        info_obr: ctrl.data().info_obr,
                        showBookingBlock: ctrl.data().config.openSkyBlocksShow,
                        infoTurnaroundFlight: ctrl.data().config.InfoTurnaroundFlight,
                        infoFlightTimeTransPax: ctrl.data().config.InfoFlightTimeTransPax,
                    })
                ]
        ];
    }
};
